import api from '$lib/api'

import { createQueryString } from '@utils'

export const fetchBenchmarks = async (
    topic = undefined,
    offset = 0,
    limit = 100,
    orderBy = 'seconds',
    orderDirection = 'desc',
) => {
    
    try {
        
        const query = createQueryString({
            topic,
            offset: offset || 0,
            limit: limit || 100,
            orderBy: orderBy ?? 'seconds',
            orderDirection: orderDirection ?? 'desc',
        })
        
        const res = await api.get(`/admin/benchmarks${query}`)
        
        return res.data
        
    } catch (e) {
        
        console.error('fetchBenchmarks', e)
        
    }
    
}

export const deleteBenchmarks = async ids => {
    
    try {
        
        const res = await api.delete('admin/benchmarks', {
            data: {
                ids,
            },
        })
        
        return res.data
        
    } catch (e) {
        
        console.error('deleteBenchmarks', e)
        
    }
    
}
